/// <reference path="../setup/_references.ts" />
module onvio.firmDashboard {
  'use strict';

  angular.module('onvio.firmDashboard')
    .config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {

      let checkPermission = (
        $q: ng.IQService,
        $state: ng.ui.IStateService,
        bmAccess: any,
        bmLicense: any,
        bmPermission: bluemoon.components.IBmPermissionService
      ) => {
        const clientDashPromises = [];
        clientDashPromises.push(bmLicense.has('Onvio.FirmDashboard'));
        clientDashPromises.push(bmPermission.has('Onvio.FirmDashboard'));
        clientDashPromises.push(bmAccess.has('Firm_Dashboard'));
        clientDashPromises.push(bmLicense.not('Application.OnvioDocumentsBasic'));
        clientDashPromises.push(bmPermission.not('GFR.ClientFlow'));
        $q.all(clientDashPromises)
          .catch(() => { $state.go('notfound', {}, { location: 'replace' }); });
      };

      $stateProvider.state('new-firm-dashboard', {
        url: '/firm-dashboard',
        templateUrl: 'firm-dashboard/firm-dashboard.html',
        controller: 'onvio.firmDashboard.FirmDashboardController as $ctrl',
        resolve: {
          'resolve.translationsLoaded': [
            '$translate', ($translate: ng.translate.ITranslateService) => {
              return $translate('Bluemoon.Practice.Common.ErrorHandler.GenericValidationError');
            }
          ],
          permission: ['$q', '$state', 'bmAccess', 'bmLicense', 'bmPermission', checkPermission]
        }
      });
    }]);
}
